import React from 'react'
import { Link } from 'react-router-dom'

const Connect = () => {
  return (
    <div className="bg-sec3 flex flex-row items-center justify-center h-60">
      <div className="flex items-center justify-between gap-40 max-w-[1200px]">
        <div className="flex flex-col">
            <div className="text-4xl font-bold font-[Montserrat] mt-14 w-[500px]">
                Your Success, Our Priority 
              </div>
              <div className="text-xl font-semibold font-[Montserrat] mt-10">
                  Connect for Tailored Solutions
              </div>
          </div>
          <div className=" flex items-center justify-center">
              <Link to='/contact' className='bg-prime text-white px-20 py-10 rounded-lg font-semibold font-[Montserrat] text-2xl'>Let's Connect</Link>
          </div>
          </div>
    </div>
  )
}

export default Connect

